import { RootActionTypes } from '@redux/modules/actionTypes';
import { RootActions } from 'types/state';
import * as ActionTypes from './actionTypes';
import { FormState, FormStateSubsectionsKeys } from './types';

export const formStateSubsectionsKeys: FormStateSubsectionsKeys[] = [
  'CITIZENSHIP_MULTIPLE',
  'CITIZENSHIP_PASSPORTS',
  'CITIZENSHIP_STATUS',
  'CITIZENSHIP_US_PASSPORT',
  'FINANCIAL_BANKRUPTCY',
  'FINANCIAL_CARD',
  'FINANCIAL_CREDIT',
  'FINANCIAL_DELINQUENT',
  'FINANCIAL_FEDERAL_DEBT',
  'FINANCIAL_GAMBLING',
  'FINANCIAL_NONPAYMENT',
  'FINANCIAL_TAXES',
  'FINANCIAL_ALIMONY',
  'FINANCIAL_CHILD_SUPPORT',
  'FINANCIAL_CIVIL_JUDGEMENT',
  'FINANCIAL_LIEN',
  'FINANCIAL_FORECLOSURE',
  'FINANCIAL_REPOSSESSION',
  'FINANCIAL_EVICTION',
  'FINANCIAL_ASSET_SEIZED',
  'FINANCIAL_NONPAYMENT_NONFEDERAL',
  'FOREIGN_ACTIVITIES_BENEFITS',
  'FOREIGN_ACTIVITIES_DIRECT',
  'FOREIGN_ACTIVITIES_INDIRECT',
  'FOREIGN_ACTIVITIES_REAL_ESTATE',
  'FOREIGN_ACTIVITIES_CURRENT',
  'FOREIGN_ACTIVITIES_FUTURE',
  'FOREIGN_ACTIVITIES_SUPPORT',
  'FOREIGN_ACTIVITIES_ONGOINGSUPPORT',
  'FOREIGN_BUSINESS_POLITICAL',
  'FOREIGN_BUSINESS_SPONSORSHIP',
  'FOREIGN_BUSINESS_ADVICE',
  'FOREIGN_BUSINESS_CONFERENCES',
  'FOREIGN_BUSINESS_CONTACT',
  'FOREIGN_BUSINESS_EMPLOYMENT',
  'FOREIGN_BUSINESS_FAMILY',
  'FOREIGN_CONTACTS',
  'FOREIGN_TRAVEL',
  'FOREIGN_BUSINESS_VENTURES',
  'FOREIGN_BUSINESS_VOTING',
  'HISTORY_EDUCATION',
  'HISTORY_EMPLOYMENT',
  'HISTORY_FEDERAL',
  'HISTORY_RESIDENCE',
  'IDENTIFICATION_BIRTH_DATE',
  'IDENTIFICATION_BIRTH_PLACE',
  'IDENTIFICATION_NAME',
  'IDENTIFICATION_SSN',
  'IDENTIFICATION_CONTACTS',
  'IDENTIFICATION_OTHER_NAMES',
  'IDENTIFICATION_PHYSICAL',
  'LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW',
  'LEGAL_ASSOCIATIONS_ADVOCATING',
  'LEGAL_INVESTIGATIONS_DEBARRED',
  'LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM',
  'LEGAL_INVESTIGATIONS_HISTORY',
  'LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES',
  'LEGAL_INVESTIGATIONS_PIV_ISSUES',
  'LEGAL_INVESTIGATIONS_FOREIGN',
  'LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW',
  'LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE',
  'LEGAL_COURT',
  'LEGAL_CRIMINAL_CONVICTIONS',
  'LEGAL_POLICE_DOMESTIC_VIOLENCE',
  'LEGAL_POLICE_OFFENSES',
  'LEGAL_POLICE_ADDITIONAL_OFFENSES',
  'LEGAL_INVESTIGATIONS_REVOKED',
  'LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION',
  'LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION',
  'LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP', // PVQ
  'LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT', // PVQ
  'LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY', // PVQ
  'LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP', // PVQ
  'LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP', // PVQ
  'LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION', // PVQ
  'LEGAL_ASSOCIATIONS_VIOLENT_ACTS', // PVQ
  'LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY', // PVQ
  'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM', // PVQ
  'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT', // PVQ
  'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION', // PVQ
  'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY', // PVQ
  'LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED',
  'LEGAL_TECHNOLOGY_NONCOMPLIANCE',
  'LEGAL_TECHNOLOGY_UNAUTHORIZED',
  'LEGAL_TECHNOLOGY_MANIPULATING',
  'LEGAL_TECHNOLOGY_DENIED',
  'LEGAL_TECHNOLOGY_UNLAWFUL',
  'MILITARY_DISCIPLINARY',
  'MILITARY_FOREIGN',
  'MILITARY_HISTORY',
  'MILITARY_SELECTIVE',
  'PACKAGE_COMMENTS',
  'PSYCHOLOGICAL_COMPETENCE',
  'PSYCHOLOGICAL_CONSULTATIONS',
  'PSYCHOLOGICAL_DIAGNOSES',
  // PSYCHOLOGICAL_CONDITIONS is hidden by default. See Question21E.
  'PSYCHOLOGICAL_CONDITIONS',
  'PSYCHOLOGICAL_HOSPITALIZATIONS',
  'RELATIONSHIPS_STATUS_COHABITANTS',
  'RELATIONSHIPS_STATUS_MARITAL',
  'RELATIONSHIPS_PEOPLE',
  'RELATIONSHIPS_RELATIVES',
  'SUBSTANCE_USE_DRUGS_CLEARANCE',
  'SUBSTANCE_USE_DRUGS_PURCHASE',
  'SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY',
  'SUBSTANCE_USE_DRUGS_USAGE',
  'SUBSTANCE_USE_ALCOHOL_NEGATIVE',
  'SUBSTANCE_USE_ALCOHOL_ORDERED',
  'SUBSTANCE_USE_DRUGS_ORDERED',
  'SUBSTANCE_USE_DRUGS_MISUSE',
  'SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT',
  'SUBSTANCE_USE_ALCOHOL_ADDITIONAL',
  'SUBSTANCE_USE_ALCOHOL_VOLUNTARY',
  'SUBSTANCE_USE_DRUGS_VOLUNTARY',
  'SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE',
  'SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE',
  'SUBSTANCE_USE_THC_USAGE',
  'SUBSTANCE_USE_THC_PURCHASE',
  'SUBSTANCE_USE_THC_CLEARANCE',
  'SUBSTANCE_USE_THC_PUBLIC_SAFETY',

];

export const initialState: FormState = {
  initialValidateFormCompleted: false,
  currentScrollValue: null,
};

// This creates a default initialState for each subsection. Thus, when the
// validation model runs, it'll loop through all the subsections and generate
// errors across the board.
formStateSubsectionsKeys.forEach(
  (key) => {
    initialState[key] = {
      data: {},
      errors: [],
      formErrors: [],
    };
  }
);

// TODO: We most likely need to revisit reducers and make sure we aren't passing
// references into the state.
// https://redux.js.org/recipes/structuring-reducers/immutable-update-patterns/

// eslint-disable-next-line default-param-last
const reducer = (state: FormState = initialState, action: RootActions): FormState => {
  switch (action.type) {
    case RootActionTypes.api.FETCH_FORM_SUCCESS: {
      const newState: FormState = { ...state };

      // This may not be the best location to handle it.
      Object.keys(action.payload.normalized).forEach((subsectionName) => {
        const key = action.payload.normalized[subsectionName]
          .subsectionKey as FormStateSubsectionsKeys;

        // @ts-ignore - newState[key] already has the properties, but the type is not aligning up.
        newState[key] = {
          ...newState[key],
          ...action.payload.normalized[subsectionName],
        };
      });

      return newState;
    }

    case ActionTypes.UPDATE_CURRENT_SCROLL_VALUE: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case ActionTypes.VALIDATE_FORM_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        initialValidateFormCompleted: true,
      };
    }

    case ActionTypes.UPDATE_SUBSECTION_SUCCESS: {
      const { subsectionValidations, subsectionKey, data } = action.payload;
      // While objects at the first level are copied (to be immutable), deeper
      // child objects are not. We'll need to fix this down the road to make
      // the entire object tree immutable.
      let returnState = { ...state };

      // Updates all subsections validations
      for (const subsection of subsectionValidations) {
        returnState = {
          ...returnState,
          [subsection.key]: {
            ...returnState[subsection.key],
            errors: [...subsection.errors],
            formErrors: [...subsection.formErrors],
            complete: subsection.complete,
          },
        };
      }

      // Update data for target subsection
      returnState = {
        ...returnState,
        [subsectionKey]: {
          ...returnState[subsectionKey],
          data: { ...data },
        },
      };

      return returnState;
    }

    case ActionTypes.UPDATE_SUBSECTION_ERRORS: {
      const { subsectionKey, errors } = action.payload;
      const formSection = state[subsectionKey as FormStateSubsectionsKeys] || {};

      return {
        ...state,
        [subsectionKey]: {
          ...formSection,
          errors,
        },
      };
    }

    case ActionTypes.UPDATE_SUBSECTION_COMPLETE: {
      const { subsectionKey, complete } = action.payload;
      const formSection = state[subsectionKey as FormStateSubsectionsKeys] || {};

      return {
        ...state,
        [subsectionKey]: {
          ...formSection,
          complete,
        },
      };
    }

    case RootActionTypes.authentication.LOGGED_OFF:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default reducer;
